module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-ons-page', {
    staticClass: "l-content",
    attrs: {
      "id": "urgences"
    }
  }, [_c('custom-toolbar', {
    attrs: {
      "backLabel": "Retour"
    }
  }, [_vm._v(_vm._s(_vm.region.name))]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('v-ons-button', {
    attrs: {
      "modifier": "large"
    },
    on: {
      "click": function($event) {
        return _vm.view(_vm.KeyholdingContact);
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-phone"
  }), _vm._v("\n      Contact\n      "), _c('i', {
    staticClass: "fas fa-phone absoluteIcon"
  })]), _vm._v(" "), (_vm.keyholding_data[_vm.region.key].brochures[_vm.$i18n.locale]) ? _c('v-ons-button', {
    attrs: {
      "modifier": "large"
    },
    on: {
      "click": function($event) {
        return _vm.view(_vm.KeyholdingBrochures);
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-map"
  }), _vm._v("\n      " + _vm._s(_vm.$t("Brochures")) + "\n      "), _c('i', {
    staticClass: "fas fa-map absoluteIcon"
  })]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41ceb6dc","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/KeyholdingRegion.vue
// module id = 209
// module chunks = 0